import { Suspense, ReactNode } from 'react';
import { CssBaseline, Container, Button, Typography, Box } from '@mui/material';
import { Loading, CheckForApplicationUpdate } from 'react-admin';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { Layout as ReactAdminLayout } from 'react-admin';
import { DrawerProvider } from '@app/misc/DrawerContext';
import { NormalizeHashRouterUrlComponent } from '@core/routing/NormalizeHashRouterUrlComponent';
import { Menu } from './Menu';
import { AppBar } from './AppBar';

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 200,
                gap: 2,
                p: 2,
            }}
            role="alert"
        >
            <Typography variant="h6">Something went wrong</Typography>
            <Typography variant="body2" color="text.secondary">
                {error?.message}
            </Typography>
            <Button variant="contained" onClick={resetErrorBoundary}>
                Try again
            </Button>
        </Box>
    );
}

export const Layout = ({ children }: { children: ReactNode }) => (
    <ReactAdminLayout menu={Menu} appBar={AppBar}>
        <NormalizeHashRouterUrlComponent />
        <DrawerProvider>
            <CssBaseline />
            <Container disableGutters>
                <main id="main-content">
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <Suspense fallback={<Loading />}>{children}</Suspense>
                    </ErrorBoundary>
                </main>
            </Container>
            <CheckForApplicationUpdate interval={120 * 1000} />
        </DrawerProvider>
    </ReactAdminLayout>
);
